"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _reactRouterDom = require("react-router-dom");
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _objects = require("@mulesoft/exchange-ui-components/lib/utils/objects");
var _classnames = _interopRequireDefault(require("classnames"));
var styles = {
  "draft-container": "DraftHeader__draft-container__6r5Ww",
  "draftContainer": "DraftHeader__draft-container__6r5Ww",
  "status-information": "DraftHeader__status-information__1Eg76",
  "statusInformation": "DraftHeader__status-information__1Eg76",
  "text": "DraftHeader__text__1tt7S",
  "icon": "DraftHeader__icon__18g6-",
  "button": "DraftHeader__button__1vCuF",
  "no-fill": "DraftHeader__no-fill__19txx",
  "noFill": "DraftHeader__no-fill__19txx",
  "draft-buttons": "DraftHeader__draft-buttons__1CU33",
  "draftButtons": "DraftHeader__draft-buttons__1CU33"
}; 
require('./DraftHeader.css');
var buttonStyles = _Button.default.themes.DefaultTheme;
var DraftHeader = function DraftHeader(_ref) {
  var buttons = _ref.buttons,
    statusText = _ref.statusText,
    statusIcon = _ref.statusIcon;
  var renderButtons = function renderButtons() {
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: styles.draftButtons,
      "data-test-id": "draft-header-buttons"
    }, buttons.map(function (element) {
      var elementId = (0, _objects.slugify)(element.title);
      var elementLabel = element.title.toLowerCase();
      if (element.href) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: "".concat(elementId, "-draft-button")
        }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          role: "button",
          "data-test-id": elementId,
          "aria-describedby": "".concat(elementId, "-description"),
          "aria-label": "Go to ".concat(elementLabel),
          className: (0, _classnames.default)(buttonStyles.button, buttonStyles.primary, buttonStyles.noFill, buttonStyles.sm, styles.button, styles.noFill),
          to: element.href
        }, element.title, /*#__PURE__*/_react.default.createElement("span", {
          id: "".concat(elementId, "-description"),
          className: "visually-hidden",
          "data-test-id": "".concat(elementId, "-draft-description")
        }, element.description)));
      }
      return /*#__PURE__*/_react.default.createElement("li", {
        key: "".concat(elementId, "-draft-button")
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "button",
        testId: "".concat(elementId, "-draft-button"),
        isLoading: !!element.isLoading,
        "aria-label": element.title,
        onClick: element.onClick,
        "aria-describedby": "".concat(elementId, "-draft-button"),
        className: (0, _classnames.default)(styles.button, (0, _defineProperty2.default)({}, styles.noFill, element.noFill)),
        size: "sm",
        kind: "primary",
        noFill: element.noFill
      }, element.title, /*#__PURE__*/_react.default.createElement("span", {
        "data-test-id": "".concat(elementId, "-draft-description"),
        className: "visually-hidden"
      }, element.description)));
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.draftContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.statusInformation
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.icon,
    "aria-hidden": true,
    "data-test-id": "draft-status-image"
  }, statusIcon), /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "status-test-id",
    className: styles.text
  }, statusText)), renderButtons());
};
var _default = exports.default = DraftHeader;
//# sourceMappingURL=DraftHeader.js.map